module.exports = __webpack_public_path__ + "static/media/cyqual.31280abb.jpg";